<template>
  <div id="bottomLeft" class="content-box-item">
    <div class="bottom-top">
      <el-image :src="require('@/assets/icons/icon-7.png')" fit="fit"/>
      <span class="top-txt">生日提醒</span>
    </div>
    <div class="bottom-bottom">
      <dv-scroll-board :config="config" style="width:100%;height:100%" />
    </div>
  </div>
</template>

<script>
   import {EChildGender} from "../../../utils/enumsUtil";

   const heard_icon = '<div class=\"heard-con\"><div class=\"heard-bg\"><img class=\"heard-icon\" src=\"https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg\" fit=\"fit\"/></div></div>';

export default {
  data() {
    return {
      config: {
        header: ['头像', '姓名', '性别', '月龄', '电话'],
        data: [
          [heard_icon, '等等', '男宝', '10个月', '13693392005'],
          [heard_icon, '心心', '女宝', '12个月', '13693392005'],
          [heard_icon, '丫丫', '男宝', '15个月', '13693392005'],
          [heard_icon, '妮妮', '女宝', '20个月', '13693392005'],
          [heard_icon, '笑笑', '男宝', '24个月', '13693392005'],
        ],
        rowNum: 3, //表格行数
        headerHeight: 45,
        headerBGC: '#FFFFFF',
        oddRowBGC: '#FFFFFF', //奇数行
        evenRowBGC: '#FFFFFF', //偶数行
        index: false,
        align: ['center', 'center', 'center', 'center', 'center'],
        columnWidth: [120, 120, 120, 120, 180]
      }
    }
  },
  //
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    cdata: {
      handler (newData) {
        this.config.data = [];
        for (let i = 0;i< newData.birthdayChildList.length;++i){
          let d = newData.birthdayChildList[i];
          let headPic = (d.headPic == null? heard_icon:d.headPic);
          let genderDes =  EChildGender(d.gender) + "宝";
          let month = d.monthCount + "个月";
          let configItem = [headPic,d.name,genderDes,month,d.phoneNumber];
          this.config.data.push(configItem);
        }

      },
      immediate: true,
      deep: true
    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
#bottomLeft {
  width: calc(100% - 15px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  .bottom-top{
    width: 90%;
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    margin-top: 5px;
  }
  .top-txt{
    font-size: 20px;
    line-height: 60px;
    text-align: center;
    margin-left: 20px;
    color: #000000;
  }
  .bottom-bottom{
    width: 96%;
    height: calc(100% - 70px);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    margin-top: 5px;
  }
  /deep/ .header-item{
    background: #ecf3fd;
    border-radius: 8px;
    color: #f49b0b;
    font-size: 18px;
    margin-left: 10px;
    margin-right: 10px;
  }
  /deep/ .row-item{
    border-bottom: 1px solid #dbdedf;
  }
  /deep/ .ceil{
    margin-left: 10px;
    margin-right: 10px;
    font-size: 18px;
    background-image:-webkit-linear-gradient(left,#0d6fb8, #63b1ff);
    -webkit-background-clip:text;
    -webkit-text-fill-color:transparent;
  }
  /deep/ .heard-con{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  /deep/ .heard-bg{
    width: 60px;
    height: 60px;
    border-radius: 50%;
    overflow: hidden;
    background-image:-webkit-linear-gradient(left,#0d6fb8, #63b1ff);
    /* 卡片阴影 */
    box-shadow: 0px 0px 8px 2px rgba(238, 56, 35, 0.09);
  }
  /deep/ .heard-icon{
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/data/bottom/bottomLeft.vue